<template>
  <transition name="fade">
    <div class="theme-preview-container">
      <div class="toolbar" style="">
        <div class="container">
          <div class="section-left">
            <md-button class="md-dense md-accent md-raised md-primary bn-baseline btn-preview-back" @click="closeModal">
              <md-icon class="">chevron_left</md-icon> BACK
            </md-button>
          </div>
          <div class="section-center"></div>
          <div class="section-right">
            <md-button class="md-icon-button btn-viewport" data-viewmode="phone_portrait" @click="setViewPort('phone_portrait')">
              <md-icon>phone_iphone</md-icon>
            </md-button>
            <md-button class="md-icon-button btn-viewport" data-viewmode="tablet_portrait" @click="setViewPort('tablet_portrait')">
              <md-icon>tablet_mac</md-icon>
            </md-button>
            <md-button class="md-icon-button btn-viewport" data-viewmode="desktop" @click="setViewPort('desktop')">
              <md-icon>desktop_windows</md-icon>
            </md-button>
            <md-button class="md-dense md-accent md-raised md-primary btn-createsite" style="color: #fff; margin-top:5px;" @click="createSite">
              CREATE SITE
            </md-button>
          </div>
        </div>
      </div>
      <div class="preview-frame dynamic-height">
        <iframe title="Template Preview" allowfullscreen :src="getPreviewUrl()" :data-viewport="getViewPort()"></iframe>
      </div>
    </div>
  </transition>
</template>
<script>
// import style from 'styles/shared-header.scss'
export default {
  props: {
    // Your props definition here...
    id: Number, // Add previewUrl as a prop
    name: String, // Add previewUrl as a prop
    previewUrl: String, // Add previewUrl as a prop
  },

  data: () => ({
    viewPort: null,
    previewToolbarHeight: 0,
  }),
  methods: {
    closeModal: function () {
      this.$store.dispatch('popModal')
    },
    createSite() {
      this.$router.push({ path: `/register`, query: { template_id: this.id } });
      this.closeModal();
    },
    getPreviewUrl: function () {
      return this.previewUrl;
    },
    setViewPort(viewport) {
      this.viewPort = viewport;
    },
    getViewPort() {
        return this.viewPort;
    },
  },
  mounted() {
  },
  beforeDestroy() {
  }
}
</script>
<style lang="scss" scoped>
.theme-preview-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .toolbar {
    .container {
      height: 50px; /* Set the height of your toolbar */
      border-bottom: 1px solid rgba(51, 50, 50, 0.1);
      display: flex;
      justify-content: space-between;
      align-items: center;

      .section-left {}
      .section-center {}
      .section-right {}
    }

    .btn-preview-back {
      text-transform: none;
      color: #fff;
      padding: 3px 3px !important;
      max-width: 75px;
    }

    .btn-createsite {
      margin-top: 5px;
    }
    .btn-viewport {
      margin-top:3px;
    }
  }

  .preview-frame {
    //overflow: hidden;
    //text-align: center;
    //--portrait-margin-top: 10px;
    //height:100%;
    //max-height:calc(100% - 52px);

    &.dynamic-height {
      flex-grow: 1; /* Take up the remaining vertical space */
      max-height: calc(100% - 50px); /* Subtract the toolbar height */
      overflow: hidden;
      text-align: center;
      --portrait-margin-top: 10px;
    }

    iframe {
      padding: 0;
      width: calc(100%); /* Set the width to 100% of the parent - 1rem */
      height: calc(100%); /* Set the height to 100% of the parent - 1rem */

      &[data-viewport="tablet_landscape"] {
        width: 1242px;
        height: calc(798px - var(--portrait-margin-top));
        margin-top: var(--portrait-margin-top);
        border: 40px solid #111;
        border-radius: 15px;
      }

      &[data-viewport="tablet_portrait"] {
        width: 901px;
        height: calc(85dvh - var(--portrait-margin-top));
        margin-top: var(--portrait-margin-top);
        border: 40px solid #111;
        border-radius: 15px;
      }

      &[data-viewport="phone_landscape"] {
        width: 759px;
        height: calc(395px - var(--portrait-margin-top));
        margin-top: var(--portrait-margin-top);
        border: 10px solid #111;
        border-radius: 15px;
      }

      &[data-viewport="phone_portrait"] {
        width: 395px;
        height: calc(762px - var(--portrait-margin-top));
        margin-top: var(--portrait-margin-top);
        border: 10px solid #111;
        border-radius: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// apps/www.bravenet.com/src/components/sitebuilder/theme-preview-modal.vue